import { BestQualityProducts, DifferentTypesGrocery, FreshnessGuaranteed } from "assets";
import { Fragment, useState } from "react";
import './index.scss'

interface Props { }

export function CarouselComp(props: Props) {
    const [current, setCurrent] = useState<number>(1)

    // useEffect(() => {
    //     const timer = setInterval(() => {
    //         if (current >= 3) {
    //             setCurrent(1)
    //         } else {c
    //             let prev = current

    //             setCurrent(prev + 1)
    //         }
    //     }, 1000)
    //     return () => clearInterval(timer)
    // })

    return <Fragment>
        <div className="carousel">

            <div className="carousel-items">
                <div className="carousel-items-item align-center">
                    <img src={FreshnessGuaranteed} alt="" />

                    <div>
                        <div className="carousel-items-item_head">quality freshness guaranteed</div>
                        <div className="carousel-items-item_body">
                            Intrinsicly fashion performance based products rather than accurate benefits...
                        </div>
                        <div className="carousel-items-item_shop-now">shop now</div>
                    </div>
                </div>
                <div className="carousel-items-item align-center">
                    <img src={DifferentTypesGrocery} alt="" />
                    <div>

                        <div className="carousel-items-item_head">
                            Best Different Type of Grocery Store
                        </div>
                        <div className="carousel-items-item_body">
                            Quickly aggregate empowered networks after emerging products...
                        </div>
                        <div className="carousel-items-item_shop-now">shop now</div>
                    </div>
                </div>
                <div className="carousel-items-item align-center">
                    <img src={BestQualityProducts} alt="" />
                    <div>

                        <div className="carousel-items-item_head">
                            The Best Quality Products Guaranteed!
                        </div>
                        <div className="carousel-items-item_body">
                            Dramatically facilitate effective total linkage for go forward processes...
                        </div>
                        <div className="carousel-items-item_shop-now">shop now</div>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
}
